(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["table"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.custom-table--collapsible').forEach(table => {
    const visibleRows = parseInt(table.dataset.visibleRows) || 4;
    const rows = table.querySelectorAll('.custom-table-row:not(.custom-table-row--header)');
    const wrapper = table.closest('.custom-table-wrapper');
    const button = wrapper.querySelector('.custom-table__toggle');
    
    rows.forEach((row, index) => {
      if (index >= visibleRows) {
        row.classList.add('is-hidden');
      }
    });

    if (rows.length <= visibleRows && button) {
      button.classList.add('is-hidden');
    }

    if (button) {
      button.addEventListener('click', () => {
        const isExpanded = table.classList.contains('is-expanded');
        
        table.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', !isExpanded);
        button.textContent = isExpanded 
          ? button.dataset.expandLabel 
          : button.dataset.collapseLabel;

        rows.forEach((row, index) => {
          if (index >= visibleRows) {
            row.classList.toggle('is-hidden', isExpanded);
          }
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
